/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthShellRouteImport } from './routes/_auth/_shell'
import { Route as AuthShellInicioRouteImport } from './routes/_auth/_shell/inicio'
import { Route as AuthShellDlqRouteImport } from './routes/_auth/_shell/dlq'
import { Route as AuthShellAuditoriaRouteImport } from './routes/_auth/_shell/auditoria'
import { Route as AuthShellUsuariosIndexRouteImport } from './routes/_auth/_shell/usuarios/index'
import { Route as AuthShellInstituicoesCursosIndexRouteImport } from './routes/_auth/_shell/instituicoes-cursos/index'
import { Route as AuthShellUsuariosIdRouteImport } from './routes/_auth/_shell/usuarios/$id'
import { Route as AuthShellUsuariosIdInscricoesSubscriptionIdRouteImport } from './routes/_auth/_shell/usuarios/$id_.inscricoes.$subscriptionId'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthShellRoute = AuthShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => AuthRoute,
} as any)
const AuthShellInicioRoute = AuthShellInicioRouteImport.update({
  id: '/inicio',
  path: '/inicio',
  getParentRoute: () => AuthShellRoute,
} as any)
const AuthShellDlqRoute = AuthShellDlqRouteImport.update({
  id: '/dlq',
  path: '/dlq',
  getParentRoute: () => AuthShellRoute,
} as any)
const AuthShellAuditoriaRoute = AuthShellAuditoriaRouteImport.update({
  id: '/auditoria',
  path: '/auditoria',
  getParentRoute: () => AuthShellRoute,
} as any)
const AuthShellUsuariosIndexRoute = AuthShellUsuariosIndexRouteImport.update({
  id: '/usuarios/',
  path: '/usuarios/',
  getParentRoute: () => AuthShellRoute,
} as any)
const AuthShellInstituicoesCursosIndexRoute =
  AuthShellInstituicoesCursosIndexRouteImport.update({
    id: '/instituicoes-cursos/',
    path: '/instituicoes-cursos/',
    getParentRoute: () => AuthShellRoute,
  } as any)
const AuthShellUsuariosIdRoute = AuthShellUsuariosIdRouteImport.update({
  id: '/usuarios/$id',
  path: '/usuarios/$id',
  getParentRoute: () => AuthShellRoute,
} as any)
const AuthShellUsuariosIdInscricoesSubscriptionIdRoute =
  AuthShellUsuariosIdInscricoesSubscriptionIdRouteImport.update({
    id: '/usuarios/$id_/inscricoes/$subscriptionId',
    path: '/usuarios/$id/inscricoes/$subscriptionId',
    getParentRoute: () => AuthShellRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auditoria': typeof AuthShellAuditoriaRoute
  '/dlq': typeof AuthShellDlqRoute
  '/inicio': typeof AuthShellInicioRoute
  '/usuarios/$id': typeof AuthShellUsuariosIdRoute
  '/instituicoes-cursos/': typeof AuthShellInstituicoesCursosIndexRoute
  '/usuarios/': typeof AuthShellUsuariosIndexRoute
  '/usuarios/$id/inscricoes/$subscriptionId': typeof AuthShellUsuariosIdInscricoesSubscriptionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auditoria': typeof AuthShellAuditoriaRoute
  '/dlq': typeof AuthShellDlqRoute
  '/inicio': typeof AuthShellInicioRoute
  '/usuarios/$id': typeof AuthShellUsuariosIdRoute
  '/instituicoes-cursos': typeof AuthShellInstituicoesCursosIndexRoute
  '/usuarios': typeof AuthShellUsuariosIndexRoute
  '/usuarios/$id/inscricoes/$subscriptionId': typeof AuthShellUsuariosIdInscricoesSubscriptionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_auth/_shell': typeof AuthShellRouteWithChildren
  '/_auth/_shell/auditoria': typeof AuthShellAuditoriaRoute
  '/_auth/_shell/dlq': typeof AuthShellDlqRoute
  '/_auth/_shell/inicio': typeof AuthShellInicioRoute
  '/_auth/_shell/usuarios/$id': typeof AuthShellUsuariosIdRoute
  '/_auth/_shell/instituicoes-cursos/': typeof AuthShellInstituicoesCursosIndexRoute
  '/_auth/_shell/usuarios/': typeof AuthShellUsuariosIndexRoute
  '/_auth/_shell/usuarios/$id_/inscricoes/$subscriptionId': typeof AuthShellUsuariosIdInscricoesSubscriptionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auditoria'
    | '/dlq'
    | '/inicio'
    | '/usuarios/$id'
    | '/instituicoes-cursos/'
    | '/usuarios/'
    | '/usuarios/$id/inscricoes/$subscriptionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auditoria'
    | '/dlq'
    | '/inicio'
    | '/usuarios/$id'
    | '/instituicoes-cursos'
    | '/usuarios'
    | '/usuarios/$id/inscricoes/$subscriptionId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_auth/_shell'
    | '/_auth/_shell/auditoria'
    | '/_auth/_shell/dlq'
    | '/_auth/_shell/inicio'
    | '/_auth/_shell/usuarios/$id'
    | '/_auth/_shell/instituicoes-cursos/'
    | '/_auth/_shell/usuarios/'
    | '/_auth/_shell/usuarios/$id_/inscricoes/$subscriptionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_shell': {
      id: '/_auth/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthShellRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_shell/inicio': {
      id: '/_auth/_shell/inicio'
      path: '/inicio'
      fullPath: '/inicio'
      preLoaderRoute: typeof AuthShellInicioRouteImport
      parentRoute: typeof AuthShellRoute
    }
    '/_auth/_shell/dlq': {
      id: '/_auth/_shell/dlq'
      path: '/dlq'
      fullPath: '/dlq'
      preLoaderRoute: typeof AuthShellDlqRouteImport
      parentRoute: typeof AuthShellRoute
    }
    '/_auth/_shell/auditoria': {
      id: '/_auth/_shell/auditoria'
      path: '/auditoria'
      fullPath: '/auditoria'
      preLoaderRoute: typeof AuthShellAuditoriaRouteImport
      parentRoute: typeof AuthShellRoute
    }
    '/_auth/_shell/usuarios/': {
      id: '/_auth/_shell/usuarios/'
      path: '/usuarios'
      fullPath: '/usuarios/'
      preLoaderRoute: typeof AuthShellUsuariosIndexRouteImport
      parentRoute: typeof AuthShellRoute
    }
    '/_auth/_shell/instituicoes-cursos/': {
      id: '/_auth/_shell/instituicoes-cursos/'
      path: '/instituicoes-cursos'
      fullPath: '/instituicoes-cursos/'
      preLoaderRoute: typeof AuthShellInstituicoesCursosIndexRouteImport
      parentRoute: typeof AuthShellRoute
    }
    '/_auth/_shell/usuarios/$id': {
      id: '/_auth/_shell/usuarios/$id'
      path: '/usuarios/$id'
      fullPath: '/usuarios/$id'
      preLoaderRoute: typeof AuthShellUsuariosIdRouteImport
      parentRoute: typeof AuthShellRoute
    }
    '/_auth/_shell/usuarios/$id_/inscricoes/$subscriptionId': {
      id: '/_auth/_shell/usuarios/$id_/inscricoes/$subscriptionId'
      path: '/usuarios/$id/inscricoes/$subscriptionId'
      fullPath: '/usuarios/$id/inscricoes/$subscriptionId'
      preLoaderRoute: typeof AuthShellUsuariosIdInscricoesSubscriptionIdRouteImport
      parentRoute: typeof AuthShellRoute
    }
  }
}

interface AuthShellRouteChildren {
  AuthShellAuditoriaRoute: typeof AuthShellAuditoriaRoute
  AuthShellDlqRoute: typeof AuthShellDlqRoute
  AuthShellInicioRoute: typeof AuthShellInicioRoute
  AuthShellUsuariosIdRoute: typeof AuthShellUsuariosIdRoute
  AuthShellInstituicoesCursosIndexRoute: typeof AuthShellInstituicoesCursosIndexRoute
  AuthShellUsuariosIndexRoute: typeof AuthShellUsuariosIndexRoute
  AuthShellUsuariosIdInscricoesSubscriptionIdRoute: typeof AuthShellUsuariosIdInscricoesSubscriptionIdRoute
}

const AuthShellRouteChildren: AuthShellRouteChildren = {
  AuthShellAuditoriaRoute: AuthShellAuditoriaRoute,
  AuthShellDlqRoute: AuthShellDlqRoute,
  AuthShellInicioRoute: AuthShellInicioRoute,
  AuthShellUsuariosIdRoute: AuthShellUsuariosIdRoute,
  AuthShellInstituicoesCursosIndexRoute: AuthShellInstituicoesCursosIndexRoute,
  AuthShellUsuariosIndexRoute: AuthShellUsuariosIndexRoute,
  AuthShellUsuariosIdInscricoesSubscriptionIdRoute:
    AuthShellUsuariosIdInscricoesSubscriptionIdRoute,
}

const AuthShellRouteWithChildren = AuthShellRoute._addFileChildren(
  AuthShellRouteChildren,
)

interface AuthRouteChildren {
  AuthShellRoute: typeof AuthShellRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthShellRoute: AuthShellRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
